/* tslint:disable */
/* eslint-disable */
/**
 * Bioplan API
 * Backend API for Bioplan, an aquaculture production planning tool.
 *
 * Contact: support@optimeeringaqua.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type {Configuration} from '../configuration';
import type {AxiosPromise, AxiosInstance, RawAxiosRequestConfig} from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common';
// @ts-ignore
import {BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap} from '../base';
// @ts-ignore
import type {Action} from '../bioplanModels';
// @ts-ignore
import type {ActionBatchDelete} from '../bioplanModels';
// @ts-ignore
import type {BatchModifyActions} from '../bioplanModels';
/**
 * PlanningActionApi - axios parameter creator
 * @export
 */
export const PlanningActionApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Batch delete multiple actions in the same plan
     * @param {ActionBatchDelete} actionBatchDelete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionsBatchDeletePost: async (
      actionBatchDelete: ActionBatchDelete,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'actionBatchDelete' is not null or undefined
      assertParamExists('actionsBatchDeletePost', 'actionBatchDelete', actionBatchDelete);
      const localVarPath = `/actions/batchDelete/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'POST', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(actionBatchDelete, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Export all actions in the filter to a CSV file
     * @param {Array<string>} planId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {Array<ActionsExportGetActionTypeEnum>} [actionType]
     * @param {Array<string>} [siteId]
     * @param {Array<string>} [cageId]
     * @param {ActionsExportGetSpeciesEnum} [species]
     * @param {Array<ActionsExportGetCertificatesEnum>} [certificates]
     * @param {number} [minBiomass]
     * @param {number} [maxBiomass]
     * @param {number} [minCount]
     * @param {number} [maxCount]
     * @param {number} [minWeight]
     * @param {number} [maxWeight]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionsExportGet: async (
      planId: Array<string>,
      startDate?: string,
      endDate?: string,
      actionType?: Array<ActionsExportGetActionTypeEnum>,
      siteId?: Array<string>,
      cageId?: Array<string>,
      species?: ActionsExportGetSpeciesEnum,
      certificates?: Array<ActionsExportGetCertificatesEnum>,
      minBiomass?: number,
      maxBiomass?: number,
      minCount?: number,
      maxCount?: number,
      minWeight?: number,
      maxWeight?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('actionsExportGet', 'planId', planId);
      const localVarPath = `/actions/export/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      if (actionType) {
        localVarQueryParameter['actionType'] = actionType;
      }

      if (planId) {
        localVarQueryParameter['planId'] = planId;
      }

      if (siteId) {
        localVarQueryParameter['siteId'] = siteId;
      }

      if (cageId) {
        localVarQueryParameter['cageId'] = cageId;
      }

      if (species !== undefined) {
        localVarQueryParameter['species'] = species;
      }

      if (certificates) {
        localVarQueryParameter['certificates'] = certificates;
      }

      if (minBiomass !== undefined) {
        localVarQueryParameter['minBiomass'] = minBiomass;
      }

      if (maxBiomass !== undefined) {
        localVarQueryParameter['maxBiomass'] = maxBiomass;
      }

      if (minCount !== undefined) {
        localVarQueryParameter['minCount'] = minCount;
      }

      if (maxCount !== undefined) {
        localVarQueryParameter['maxCount'] = maxCount;
      }

      if (minWeight !== undefined) {
        localVarQueryParameter['minWeight'] = minWeight;
      }

      if (maxWeight !== undefined) {
        localVarQueryParameter['maxWeight'] = maxWeight;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Get all actions in the filter
     * @param {Array<string>} planId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {Array<ActionsGetActionTypeEnum>} [actionType]
     * @param {Array<string>} [siteId]
     * @param {Array<string>} [cageId]
     * @param {ActionsGetSpeciesEnum} [species]
     * @param {Array<ActionsGetCertificatesEnum>} [certificates]
     * @param {number} [minBiomass]
     * @param {number} [maxBiomass]
     * @param {number} [minCount]
     * @param {number} [maxCount]
     * @param {number} [minWeight]
     * @param {number} [maxWeight]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionsGet: async (
      planId: Array<string>,
      startDate?: string,
      endDate?: string,
      actionType?: Array<ActionsGetActionTypeEnum>,
      siteId?: Array<string>,
      cageId?: Array<string>,
      species?: ActionsGetSpeciesEnum,
      certificates?: Array<ActionsGetCertificatesEnum>,
      minBiomass?: number,
      maxBiomass?: number,
      minCount?: number,
      maxCount?: number,
      minWeight?: number,
      maxWeight?: number,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'planId' is not null or undefined
      assertParamExists('actionsGet', 'planId', planId);
      const localVarPath = `/actions/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'GET', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      if (startDate !== undefined) {
        localVarQueryParameter['startDate'] =
          (startDate as any) instanceof Date ? (startDate as any).toISOString().substring(0, 10) : startDate;
      }

      if (endDate !== undefined) {
        localVarQueryParameter['endDate'] =
          (endDate as any) instanceof Date ? (endDate as any).toISOString().substring(0, 10) : endDate;
      }

      if (actionType) {
        localVarQueryParameter['actionType'] = actionType;
      }

      if (planId) {
        localVarQueryParameter['planId'] = planId;
      }

      if (siteId) {
        localVarQueryParameter['siteId'] = siteId;
      }

      if (cageId) {
        localVarQueryParameter['cageId'] = cageId;
      }

      if (species !== undefined) {
        localVarQueryParameter['species'] = species;
      }

      if (certificates) {
        localVarQueryParameter['certificates'] = certificates;
      }

      if (minBiomass !== undefined) {
        localVarQueryParameter['minBiomass'] = minBiomass;
      }

      if (maxBiomass !== undefined) {
        localVarQueryParameter['maxBiomass'] = maxBiomass;
      }

      if (minCount !== undefined) {
        localVarQueryParameter['minCount'] = minCount;
      }

      if (maxCount !== undefined) {
        localVarQueryParameter['maxCount'] = maxCount;
      }

      if (minWeight !== undefined) {
        localVarQueryParameter['minWeight'] = minWeight;
      }

      if (maxWeight !== undefined) {
        localVarQueryParameter['maxWeight'] = maxWeight;
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Lock actions
     * @param {BatchModifyActions} batchModifyActions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionsLockPut: async (
      batchModifyActions: BatchModifyActions,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'batchModifyActions' is not null or undefined
      assertParamExists('actionsLockPut', 'batchModifyActions', batchModifyActions);
      const localVarPath = `/actions/lock/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(batchModifyActions, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary Unlock actions
     * @param {BatchModifyActions} batchModifyActions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionsUnlockPut: async (
      batchModifyActions: BatchModifyActions,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'batchModifyActions' is not null or undefined
      assertParamExists('actionsUnlockPut', 'batchModifyActions', batchModifyActions);
      const localVarPath = `/actions/unlock/`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = {method: 'PUT', ...baseOptions, ...options};
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      // authentication bearerAuth required
      // http bearer authentication required
      await setBearerAuthToObject(localVarHeaderParameter, configuration);

      localVarHeaderParameter['Content-Type'] = 'application/json';

      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
      localVarRequestOptions.data = serializeDataIfNeeded(batchModifyActions, localVarRequestOptions, configuration);

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * PlanningActionApi - functional programming interface
 * @export
 */
export const PlanningActionApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = PlanningActionApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary Batch delete multiple actions in the same plan
     * @param {ActionBatchDelete} actionBatchDelete
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionsBatchDeletePost(
      actionBatchDelete: ActionBatchDelete,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.actionsBatchDeletePost(actionBatchDelete, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningActionApi.actionsBatchDeletePost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Export all actions in the filter to a CSV file
     * @param {Array<string>} planId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {Array<ActionsExportGetActionTypeEnum>} [actionType]
     * @param {Array<string>} [siteId]
     * @param {Array<string>} [cageId]
     * @param {ActionsExportGetSpeciesEnum} [species]
     * @param {Array<ActionsExportGetCertificatesEnum>} [certificates]
     * @param {number} [minBiomass]
     * @param {number} [maxBiomass]
     * @param {number} [minCount]
     * @param {number} [maxCount]
     * @param {number} [minWeight]
     * @param {number} [maxWeight]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionsExportGet(
      planId: Array<string>,
      startDate?: string,
      endDate?: string,
      actionType?: Array<ActionsExportGetActionTypeEnum>,
      siteId?: Array<string>,
      cageId?: Array<string>,
      species?: ActionsExportGetSpeciesEnum,
      certificates?: Array<ActionsExportGetCertificatesEnum>,
      minBiomass?: number,
      maxBiomass?: number,
      minCount?: number,
      maxCount?: number,
      minWeight?: number,
      maxWeight?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Error>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.actionsExportGet(
        planId,
        startDate,
        endDate,
        actionType,
        siteId,
        cageId,
        species,
        certificates,
        minBiomass,
        maxBiomass,
        minCount,
        maxCount,
        minWeight,
        maxWeight,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningActionApi.actionsExportGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Get all actions in the filter
     * @param {Array<string>} planId
     * @param {string} [startDate]
     * @param {string} [endDate]
     * @param {Array<ActionsGetActionTypeEnum>} [actionType]
     * @param {Array<string>} [siteId]
     * @param {Array<string>} [cageId]
     * @param {ActionsGetSpeciesEnum} [species]
     * @param {Array<ActionsGetCertificatesEnum>} [certificates]
     * @param {number} [minBiomass]
     * @param {number} [maxBiomass]
     * @param {number} [minCount]
     * @param {number} [maxCount]
     * @param {number} [minWeight]
     * @param {number} [maxWeight]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionsGet(
      planId: Array<string>,
      startDate?: string,
      endDate?: string,
      actionType?: Array<ActionsGetActionTypeEnum>,
      siteId?: Array<string>,
      cageId?: Array<string>,
      species?: ActionsGetSpeciesEnum,
      certificates?: Array<ActionsGetCertificatesEnum>,
      minBiomass?: number,
      maxBiomass?: number,
      minCount?: number,
      maxCount?: number,
      minWeight?: number,
      maxWeight?: number,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Action>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.actionsGet(
        planId,
        startDate,
        endDate,
        actionType,
        siteId,
        cageId,
        species,
        certificates,
        minBiomass,
        maxBiomass,
        minCount,
        maxCount,
        minWeight,
        maxWeight,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningActionApi.actionsGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Lock actions
     * @param {BatchModifyActions} batchModifyActions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionsLockPut(
      batchModifyActions: BatchModifyActions,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.actionsLockPut(batchModifyActions, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningActionApi.actionsLockPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary Unlock actions
     * @param {BatchModifyActions} batchModifyActions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async actionsUnlockPut(
      batchModifyActions: BatchModifyActions,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.actionsUnlockPut(batchModifyActions, options);
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['PlanningActionApi.actionsUnlockPut']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * PlanningActionApi - factory interface
 * @export
 */
export const PlanningActionApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = PlanningActionApiFp(configuration);
  return {
    /**
     *
     * @summary Batch delete multiple actions in the same plan
     * @param {PlanningActionApiActionsBatchDeletePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionsBatchDeletePost(
      requestParameters: PlanningActionApiActionsBatchDeletePostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .actionsBatchDeletePost(requestParameters.actionBatchDelete, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Export all actions in the filter to a CSV file
     * @param {PlanningActionApiActionsExportGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionsExportGet(
      requestParameters: PlanningActionApiActionsExportGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Error> {
      return localVarFp
        .actionsExportGet(
          requestParameters.planId,
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.actionType,
          requestParameters.siteId,
          requestParameters.cageId,
          requestParameters.species,
          requestParameters.certificates,
          requestParameters.minBiomass,
          requestParameters.maxBiomass,
          requestParameters.minCount,
          requestParameters.maxCount,
          requestParameters.minWeight,
          requestParameters.maxWeight,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Get all actions in the filter
     * @param {PlanningActionApiActionsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionsGet(
      requestParameters: PlanningActionApiActionsGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<Array<Action>> {
      return localVarFp
        .actionsGet(
          requestParameters.planId,
          requestParameters.startDate,
          requestParameters.endDate,
          requestParameters.actionType,
          requestParameters.siteId,
          requestParameters.cageId,
          requestParameters.species,
          requestParameters.certificates,
          requestParameters.minBiomass,
          requestParameters.maxBiomass,
          requestParameters.minCount,
          requestParameters.maxCount,
          requestParameters.minWeight,
          requestParameters.maxWeight,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Lock actions
     * @param {PlanningActionApiActionsLockPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionsLockPut(
      requestParameters: PlanningActionApiActionsLockPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .actionsLockPut(requestParameters.batchModifyActions, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary Unlock actions
     * @param {PlanningActionApiActionsUnlockPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    actionsUnlockPut(
      requestParameters: PlanningActionApiActionsUnlockPutRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<void> {
      return localVarFp
        .actionsUnlockPut(requestParameters.batchModifyActions, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for actionsBatchDeletePost operation in PlanningActionApi.
 * @export
 * @interface PlanningActionApiActionsBatchDeletePostRequest
 */
export interface PlanningActionApiActionsBatchDeletePostRequest {
  /**
   *
   * @type {ActionBatchDelete}
   * @memberof PlanningActionApiActionsBatchDeletePost
   */
  readonly actionBatchDelete: ActionBatchDelete;
}

/**
 * Request parameters for actionsExportGet operation in PlanningActionApi.
 * @export
 * @interface PlanningActionApiActionsExportGetRequest
 */
export interface PlanningActionApiActionsExportGetRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly planId: Array<string>;

  /**
   *
   * @type {string}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly endDate?: string;

  /**
   *
   * @type {Array<'input' | 'harvest' | 'transferOut' | 'transferIn' | 'delousing' | 'liveFishTransaction'>}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly actionType?: Array<ActionsExportGetActionTypeEnum>;

  /**
   *
   * @type {Array<string>}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly siteId?: Array<string>;

  /**
   *
   * @type {Array<string>}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly cageId?: Array<string>;

  /**
   *
   * @type {'salmon' | 'trout'}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly species?: ActionsExportGetSpeciesEnum;

  /**
   *
   * @type {Array<'ASC' | 'Debio' | 'FOS' | 'GlobalGAP' | 'Naturland' | 'Organic' | 'Practice_GAABAP' | 'SoilAssociation' | 'Gladlaks' | 'STP'>}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly certificates?: Array<ActionsExportGetCertificatesEnum>;

  /**
   *
   * @type {number}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly minBiomass?: number;

  /**
   *
   * @type {number}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly maxBiomass?: number;

  /**
   *
   * @type {number}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly minCount?: number;

  /**
   *
   * @type {number}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly maxCount?: number;

  /**
   *
   * @type {number}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly minWeight?: number;

  /**
   *
   * @type {number}
   * @memberof PlanningActionApiActionsExportGet
   */
  readonly maxWeight?: number;
}

/**
 * Request parameters for actionsGet operation in PlanningActionApi.
 * @export
 * @interface PlanningActionApiActionsGetRequest
 */
export interface PlanningActionApiActionsGetRequest {
  /**
   *
   * @type {Array<string>}
   * @memberof PlanningActionApiActionsGet
   */
  readonly planId: Array<string>;

  /**
   *
   * @type {string}
   * @memberof PlanningActionApiActionsGet
   */
  readonly startDate?: string;

  /**
   *
   * @type {string}
   * @memberof PlanningActionApiActionsGet
   */
  readonly endDate?: string;

  /**
   *
   * @type {Array<'input' | 'harvest' | 'transferOut' | 'transferIn' | 'delousing' | 'liveFishTransaction'>}
   * @memberof PlanningActionApiActionsGet
   */
  readonly actionType?: Array<ActionsGetActionTypeEnum>;

  /**
   *
   * @type {Array<string>}
   * @memberof PlanningActionApiActionsGet
   */
  readonly siteId?: Array<string>;

  /**
   *
   * @type {Array<string>}
   * @memberof PlanningActionApiActionsGet
   */
  readonly cageId?: Array<string>;

  /**
   *
   * @type {'salmon' | 'trout'}
   * @memberof PlanningActionApiActionsGet
   */
  readonly species?: ActionsGetSpeciesEnum;

  /**
   *
   * @type {Array<'ASC' | 'Debio' | 'FOS' | 'GlobalGAP' | 'Naturland' | 'Organic' | 'Practice_GAABAP' | 'SoilAssociation' | 'Gladlaks' | 'STP'>}
   * @memberof PlanningActionApiActionsGet
   */
  readonly certificates?: Array<ActionsGetCertificatesEnum>;

  /**
   *
   * @type {number}
   * @memberof PlanningActionApiActionsGet
   */
  readonly minBiomass?: number;

  /**
   *
   * @type {number}
   * @memberof PlanningActionApiActionsGet
   */
  readonly maxBiomass?: number;

  /**
   *
   * @type {number}
   * @memberof PlanningActionApiActionsGet
   */
  readonly minCount?: number;

  /**
   *
   * @type {number}
   * @memberof PlanningActionApiActionsGet
   */
  readonly maxCount?: number;

  /**
   *
   * @type {number}
   * @memberof PlanningActionApiActionsGet
   */
  readonly minWeight?: number;

  /**
   *
   * @type {number}
   * @memberof PlanningActionApiActionsGet
   */
  readonly maxWeight?: number;
}

/**
 * Request parameters for actionsLockPut operation in PlanningActionApi.
 * @export
 * @interface PlanningActionApiActionsLockPutRequest
 */
export interface PlanningActionApiActionsLockPutRequest {
  /**
   *
   * @type {BatchModifyActions}
   * @memberof PlanningActionApiActionsLockPut
   */
  readonly batchModifyActions: BatchModifyActions;
}

/**
 * Request parameters for actionsUnlockPut operation in PlanningActionApi.
 * @export
 * @interface PlanningActionApiActionsUnlockPutRequest
 */
export interface PlanningActionApiActionsUnlockPutRequest {
  /**
   *
   * @type {BatchModifyActions}
   * @memberof PlanningActionApiActionsUnlockPut
   */
  readonly batchModifyActions: BatchModifyActions;
}

/**
 * PlanningActionApi - object-oriented interface
 * @export
 * @class PlanningActionApi
 * @extends {BaseAPI}
 */
export class PlanningActionApi extends BaseAPI {
  /**
   *
   * @summary Batch delete multiple actions in the same plan
   * @param {PlanningActionApiActionsBatchDeletePostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningActionApi
   */
  public actionsBatchDeletePost(
    requestParameters: PlanningActionApiActionsBatchDeletePostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningActionApiFp(this.configuration)
      .actionsBatchDeletePost(requestParameters.actionBatchDelete, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Export all actions in the filter to a CSV file
   * @param {PlanningActionApiActionsExportGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningActionApi
   */
  public actionsExportGet(
    requestParameters: PlanningActionApiActionsExportGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningActionApiFp(this.configuration)
      .actionsExportGet(
        requestParameters.planId,
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.actionType,
        requestParameters.siteId,
        requestParameters.cageId,
        requestParameters.species,
        requestParameters.certificates,
        requestParameters.minBiomass,
        requestParameters.maxBiomass,
        requestParameters.minCount,
        requestParameters.maxCount,
        requestParameters.minWeight,
        requestParameters.maxWeight,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Get all actions in the filter
   * @param {PlanningActionApiActionsGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningActionApi
   */
  public actionsGet(requestParameters: PlanningActionApiActionsGetRequest, options?: RawAxiosRequestConfig) {
    return PlanningActionApiFp(this.configuration)
      .actionsGet(
        requestParameters.planId,
        requestParameters.startDate,
        requestParameters.endDate,
        requestParameters.actionType,
        requestParameters.siteId,
        requestParameters.cageId,
        requestParameters.species,
        requestParameters.certificates,
        requestParameters.minBiomass,
        requestParameters.maxBiomass,
        requestParameters.minCount,
        requestParameters.maxCount,
        requestParameters.minWeight,
        requestParameters.maxWeight,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Lock actions
   * @param {PlanningActionApiActionsLockPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningActionApi
   */
  public actionsLockPut(requestParameters: PlanningActionApiActionsLockPutRequest, options?: RawAxiosRequestConfig) {
    return PlanningActionApiFp(this.configuration)
      .actionsLockPut(requestParameters.batchModifyActions, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary Unlock actions
   * @param {PlanningActionApiActionsUnlockPutRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof PlanningActionApi
   */
  public actionsUnlockPut(
    requestParameters: PlanningActionApiActionsUnlockPutRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return PlanningActionApiFp(this.configuration)
      .actionsUnlockPut(requestParameters.batchModifyActions, options)
      .then((request) => request(this.axios, this.basePath));
  }
}

/**
 * @export
 */
export const ActionsExportGetActionTypeEnum = {
  Input: 'input',
  Harvest: 'harvest',
  TransferOut: 'transferOut',
  TransferIn: 'transferIn',
  Delousing: 'delousing',
  LiveFishTransaction: 'liveFishTransaction',
} as const;
export type ActionsExportGetActionTypeEnum =
  (typeof ActionsExportGetActionTypeEnum)[keyof typeof ActionsExportGetActionTypeEnum];
/**
 * @export
 */
export const ActionsExportGetSpeciesEnum = {
  Salmon: 'salmon',
  Trout: 'trout',
} as const;
export type ActionsExportGetSpeciesEnum =
  (typeof ActionsExportGetSpeciesEnum)[keyof typeof ActionsExportGetSpeciesEnum];
/**
 * @export
 */
export const ActionsExportGetCertificatesEnum = {
  Asc: 'ASC',
  Debio: 'Debio',
  Fos: 'FOS',
  GlobalGap: 'GlobalGAP',
  Naturland: 'Naturland',
  Organic: 'Organic',
  PracticeGaabap: 'Practice_GAABAP',
  SoilAssociation: 'SoilAssociation',
  Gladlaks: 'Gladlaks',
  Stp: 'STP',
} as const;
export type ActionsExportGetCertificatesEnum =
  (typeof ActionsExportGetCertificatesEnum)[keyof typeof ActionsExportGetCertificatesEnum];
/**
 * @export
 */
export const ActionsGetActionTypeEnum = {
  Input: 'input',
  Harvest: 'harvest',
  TransferOut: 'transferOut',
  TransferIn: 'transferIn',
  Delousing: 'delousing',
  LiveFishTransaction: 'liveFishTransaction',
} as const;
export type ActionsGetActionTypeEnum = (typeof ActionsGetActionTypeEnum)[keyof typeof ActionsGetActionTypeEnum];
/**
 * @export
 */
export const ActionsGetSpeciesEnum = {
  Salmon: 'salmon',
  Trout: 'trout',
} as const;
export type ActionsGetSpeciesEnum = (typeof ActionsGetSpeciesEnum)[keyof typeof ActionsGetSpeciesEnum];
/**
 * @export
 */
export const ActionsGetCertificatesEnum = {
  Asc: 'ASC',
  Debio: 'Debio',
  Fos: 'FOS',
  GlobalGap: 'GlobalGAP',
  Naturland: 'Naturland',
  Organic: 'Organic',
  PracticeGaabap: 'Practice_GAABAP',
  SoilAssociation: 'SoilAssociation',
  Gladlaks: 'Gladlaks',
  Stp: 'STP',
} as const;
export type ActionsGetCertificatesEnum = (typeof ActionsGetCertificatesEnum)[keyof typeof ActionsGetCertificatesEnum];
